import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IListBehaviorConfiguration, listBehaviorConfigurationProperties } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { type IListBehaviorConfigState } from './types';

export const RETRIEVE_LIST_BEHAVIOR_CONFIGS = 'retrieveListBehaviorConfigs';

export const actions: ActionTree<IListBehaviorConfigState, unknown> = {
    async [RETRIEVE_LIST_BEHAVIOR_CONFIGS](context): Promise<number[]> {
        const query = queryBuilder.build();
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query,
            properties: listBehaviorConfigurationProperties.DEFAULT
        });
        return idList;
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IListBehaviorConfiguration[] }) {
        dataObjectList.forEach((listBehaviorConfig) => {
            if (listBehaviorConfig.targetValue) {
                context.state.listBehaviorConfigurationByTarget.set(listBehaviorConfig.targetValue, listBehaviorConfig.dobjId);
            } else if (listBehaviorConfig.target) {
                context.state.listBehaviorConfigurationByTarget.set(listBehaviorConfig.target, listBehaviorConfig.dobjId);
            }
            context.state.dataObjectList.set(listBehaviorConfig.dobjId, listBehaviorConfig);
        });
    }
};
